import
  React, {
  useEffect,
  useState
} from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  HContainer,
  VContainer
} from '@vodacom/web-common';

import {
  TabBar
} from './TabBar';

import {
  CustomColors
} from '../../constants';

import
  styled
from 'styled-components';

import {
  isEqual
} from 'helpers';

const Container = styled(HContainer)`
  width: 100%;
  display: flex;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TabView = props => {

  const [
    state,
    setState
  ] = useState({
    selectedTab: props.tabList[0]
  });

  useEffect(() => {

    props.defaultTab && setState(prevState => ({
      ...prevState,
      selectedTab: props.defaultTab
    }));

  }, [ props.defaultTab ]);

  const setupTagView = (tab) => {

    if (props.tagViewData && isEqual(tab.value, 'advances')) {

      window?.utag?.view({
        ...props.tagViewData,
        journey_step: 'cbu: connectu: airtime advance: dashboard: your history: active'
      });
    }

    if (props.tagViewData && isEqual(tab.value, 'repayments')) {

      window?.utag?.view({
        ...props.tagViewData,
        journey_step: 'cbu: connectu: airtime advance: dashboard: your history: repayment'
      });
    }
  };

  const renderTabData = () => {

    if (!props.tabData || !props.tabData.length) {
      return;
    }

    const viewData = props.tabData.filter(data => {

      return data.value === state.selectedTab?.value;
    })?.[0];

    return (

      viewData.component
    );
  };

  return (

    <VContainer
      width={'100%'}>

      <Container
        justifyContent={props.justifyContent}>

        <TabBar
          activeColor={CustomColors.Grey10}
          fontSize='16px'
          inactiveColor={CustomColors.Grey8}
          inActiveBorderBottom={props.inActiveBorderBottom}
          borderBottom={props.borderBottom}
          borderBottomSize={props.borderBottomSize}
          margin={props.margin}
          width={props.width}
          flex={props.flex}
          tabs={props.tabList}
          defaultTabValue={props.defaultTab?.value}
          onTabClicked={tab => {

            if (!tab?.value || state?.selectedTab?.value === tab.value) {
              return;
            }

            props.onTabClick?.(tab);

            setupTagView(tab);

            setState(prevState => ({
              ...prevState,
              selectedTab: tab
            }));
          }} />

      </Container>

      {renderTabData()}

    </VContainer>
  );
};

TabView.propTypes = {
  tabList: PropTypes.array.isRequired,
  tabData: PropTypes.array.isRequired,
  margin: PropTypes.string.isRequired,
  justifyContent: PropTypes.string,
  borderBottom: PropTypes.string,
  borderBottomSize: PropTypes.string,
  onTabClick: PropTypes.func,
  tagViewData: PropTypes.object,
  defaultTab: PropTypes.object
};

TabView.defaultProps = {
  tabList: [],
  tabData: [],
  margin: '0',
  justifyContent: null,
  borderBottom: null,
  borderBottomSize: null,
  onTabClick: null,
  tagViewData: {},
  defaultTab: null
};
